import { slick } from 'slick-carousel';
export const PostGridSliderController = () => {
  enquire.register('screen and (max-width:768px)', {

    match : () => {
      $('.post-grid--slider-on-mobile').each((i, el) => {
        const $slider = $(el);
        $slider.slick({
          infinite: false,
          slidesToShow: 1.5,
          slidesToScroll: 1,
          arrows: false
        });
      })
    },

    unmatch : () => {
      $('.post-grid--slider-on-mobile').each((i, el) => {
        const $slider = $(el);
        if($slider.hasClass('slick-initialized')) {
          $slider.slick('destroy');
        }
      })
    },

  });
}



// WEBPACK FOOTER //
// ./src/js/controllers/PostGridSliderController.js